import { createFileRoute, redirect } from '@tanstack/react-router';
import { claveYaElegida } from '@/lib/claveElegida';
import { esperarSesion } from '@/lib/sesion';
import { FormCambiarClave } from '@/admin/FormCambiarClave';
import { LogoTallerza } from '@/marca/Logo';

// First sign-in with the temporary password an admin gave (or after a
// reset): the session exists but every other page redirects here until the
// person picks their own password (claim debeCambiarPassword).
export const Route = createFileRoute('/cambiar-clave')({
  beforeLoad: async () => {
    const s = await esperarSesion();
    if (s.estado !== 'activa') throw redirect({ to: '/ingresar' });
    if (!s.debeCambiarPassword) throw redirect({ to: '/' });
    // It may already be their own (picked through a reset link): the server checks.
    if (await claveYaElegida(s)) throw redirect({ to: '/', replace: true });
    return { sesion: s };
  },
  component: Pagina,
});

function Pagina() {
  const { sesion } = Route.useRouteContext();
  const navegar = Route.useNavigate();
  return (
    <main className="grid min-h-dvh place-items-center bg-bg px-6 py-10">
      <div className="w-full max-w-[400px]">
        <LogoTallerza tamano="sm" />
        <h1 className="titulo mt-8 text-[30px] leading-tight">Crea tu contraseña</h1>
        <p className="mt-2 text-[15px] leading-relaxed text-text-2">
          Entraste con una contraseña temporal. Elige una propia para{' '}
          <b className="text-text-long">{sesion.email}</b>: la usarás en el backoffice y en la app.
        </p>
        <FormCambiarClave
          email={sesion.email ?? ''}
          onListo={() => navegar({ to: '/', replace: true })}
          onSalir={() => navegar({ to: '/ingresar', replace: true })}
        />
      </div>
    </main>
  );
}
